/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginWithEmailAndPasswordRequest
 */
export interface LoginWithEmailAndPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginWithEmailAndPasswordRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof LoginWithEmailAndPasswordRequest
     */
    password: string;
}

/**
 * Check if a given object implements the LoginWithEmailAndPasswordRequest interface.
 */
export function instanceOfLoginWithEmailAndPasswordRequest(value: object): value is LoginWithEmailAndPasswordRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function LoginWithEmailAndPasswordRequestFromJSON(json: any): LoginWithEmailAndPasswordRequest {
    return LoginWithEmailAndPasswordRequestFromJSONTyped(json, false);
}

export function LoginWithEmailAndPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginWithEmailAndPasswordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function LoginWithEmailAndPasswordRequestToJSON(json: any): LoginWithEmailAndPasswordRequest {
    return LoginWithEmailAndPasswordRequestToJSONTyped(json, false);
}

export function LoginWithEmailAndPasswordRequestToJSONTyped(value?: LoginWithEmailAndPasswordRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'password': value['password'],
    };
}

